/* eslint-disable react-hooks/exhaustive-deps */
import { OpenInNewWindow } from "@/Helpers/helper";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shadcnComponents/ui/tooltip";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/shadcnComponents/ui/alert-dialog";
import {
  ArrowRight,
  Building,
  Check,
  CircleCheck,
  Info,
  InfoIcon,
  Sparkles,
} from "lucide-react";
import { Button } from "@/shadcnComponents/ui/button";
import {
  ChipsCard,
  getPlatformColor,
  InfoToolTip,
  profileStrengthBackground,
  profileStrengthText,
} from "./DashboardAtoms";
import { useEffect, useState } from "react";
import { IoMdOpen } from "react-icons/io";
import { Edit2Icon, LinkIcon, User2Icon } from "lucide-react";
import { cn } from "@/lib/utils";
import mixpanel from "mixpanel-browser";
import {
  PopupCard,
  TopPostCard,
} from "@/Pages/Influencer/PublicProfile/Component";
import { VscGlobe } from "react-icons/vsc";
import { toast } from "react-toastify";
import axios from "axios";
import { MdContentCopy } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { BsWhatsapp } from "react-icons/bs";
import { IoPersonOutline } from "react-icons/io5";
import { Dialog, DialogContent } from "@/shadcnComponents/ui/dialog";
import { RadioGroup, RadioGroupItem } from "@/shadcnComponents/ui/radio-group";
import { Label } from "@/shadcnComponents/ui/label";
import { Star, X } from "lucide-react";
import { Textarea } from "@/shadcnComponents/ui/textarea";
import { CardFooter } from "@/shadcnComponents/ui/card";
import { useToast } from "@/shadcnComponents/ui/use-toast";
import { useInfluencer } from "@/Providers/Influencer";
import { Input } from "@/shadcnComponents/ui/input";
import { useAuth } from "@/Providers/Auth";

export const MetricsCard: React.FC<MetricsCardProps> = ({
  icon,
  value,
  title,
  tooltip,
}) => {
  return (
    <div
      className={`w-full md:w-auto flex p-2 md:p-[22px] rounded-[10px] bg-[#1B1F23] h-full`}
    >
      <div className="flex flex-row md:flex-row items-center gap-2 md:gap-[12px]  md:text-start w-full md:w-auto">
        {icon && <div className="flex items-center justify-center">{icon}</div>}
        <div className="flex flex-col">
          <span className="text-[#8F8F8F] font-[Inter] text-[16px] not-italic font-bold leading-[normal]">
            {value}
          </span>
          <div className="text-[#8F8F8F] cursor-pointer flex flex-row justify-center items-center gap-1 md:justify-start font-[Inter] text-[12px] not-italic font-normal leading-[normal] md:flex-row">
            {title && <span className="w-auto">{title}</span>}

            {tooltip && (
              <TooltipProvider>
                <Tooltip>
                  {tooltip && (
                    <TooltipTrigger asChild>
                      {tooltip?.tigger ? (
                        tooltip?.tigger
                      ) : (
                        <InfoIcon size={15} className="shrink-0" />
                      )}
                    </TooltipTrigger>
                  )}
                  <TooltipContent className="border-none bg-black text-white/70">
                    {tooltip?.content}
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export const CollabCard: React.FC<CollabCardProps> = ({
  brandName,
  brandWebsiteLink,
  actionButton,
  lastSyncedTimeStamp,
  statusChip,
  bottomSectionDataArray,
  collabTypeChip,
  collabId,
  ratingGiven,
  status,
  postTracking,
}) => {
  const { toast } = useToast();
  const influencerState = useInfluencer();
  const authState = useAuth();
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState("");
  const [hoverRating, setHoverRating] = useState(0);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [experienceRating, setExperienceRating] = useState(0);
  const [earningsRating, setEarningsRating] = useState("");
  const [creatorFreedom, setCreatorFreedom] = useState("yes");
  const [showSuccessCard, setShowSuccessCard] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [bounce, setBounce] = useState(false);
  const [hearts, setHearts] = useState<
    { x: number; y: number; size: number; opacity: number }[]
  >([]);

  const campaignEnded = true;

  const handleRatingClick = (value: number) => {
    if (ratingGiven?.status === 1) {
      setRating(ratingGiven?.rating);
      return;
    } else if (isSubmitted) {
      return;
    }
    setRating(value);
    setExperienceRating(value);
    setIsDialogOpen(true);
  };

  const handleMouseEnter = (value: number) => {
    if (ratingGiven?.status === 1 || isSubmitted) {
      return;
    }
    setHoverRating(value);
  };

  const handleMouseLeave = () => {
    setHoverRating(0);
  };

  const handleSubmitFeedback = async () => {
    setIsSubmitting(true);
    if (!rating || !earningsRating || !creatorFreedom || !review) {
      setIsSubmitting(false);
      return toast({
        title: "Please fill out all fields",
        variant: "destructive",
      });
    }
    const result = await influencerState?.submitCollabRating({
      rating: experienceRating,
      categories: {
        earningsRating,
        creativeFreedom: creatorFreedom,
      },
      review,
      collabId,
    });
    if (result?.success) {
      setIsSubmitting(false);
      setIsDialogOpen(false);
      setShowSuccessCard(true);
      setIsSubmitted(true);
      const newHearts = [];
      for (let i = 0; i < 10; i++) {
        newHearts.push({
          x: Math.random() * 80 + 10, // 10-90%
          y: Math.random() * 40 + 10, // 10-50%
          size: Math.random() * 10 + 10, // 10-20px
          opacity: Math.random() * 0.5 + 0.5, // 0.5-1
        });
      }
      setHearts(newHearts);
    } else {
      setIsSubmitting(false);
      toast({
        title: "Failed to submit feedback",
        variant: "destructive",
      });
    }
  };

  // Animation effect
  useEffect(() => {
    if (showSuccessCard) {
      const bounceInterval = setInterval(() => {
        setBounce((prev) => !prev);
      }, 500);

      return () => clearInterval(bounceInterval);
    }
  }, [showSuccessCard]);
  useEffect(() => {
    if (ratingGiven?.status === 1) {
      setRating(ratingGiven?.rating);
    }
  }, [ratingGiven]);

  return (
    <>
      <div className="relative flex p-4 flex-col items-start gap-5 bg-[#1B1F23] rounded-lg font-inter">
        <div className="flex gap-2">
          {statusChip}
          {collabTypeChip}
        </div>
        <div className="w-full flex gap-5 justify-between flex-col sm:flex-row">
          <div className="flex gap-5 items-center">
            <div className="p-3 flex items-center justify-center rounded-sm bg-black text-[#CEC9C9]">
              <Building size={30} />
            </div>
            <div className="flex flex-col gap-1">
              <span className="text-[#FFF] font-[Inter] text-[16px] not-italic font-semibold leading-[20px]">
                {brandName}
              </span>
              <span
                className="text-[#919191] font-[Inter] text-[12px] not-italic font-normal leading-[20px] hover:underline cursor-pointer"
                onClick={() => OpenInNewWindow({ link: brandWebsiteLink })}
              >
                Website link
              </span>
            </div>
          </div>
          {!postTracking?.updatedAt && (
            <div className="md:flex flex-col items-center gap-1 hidden ">
              {actionButton}
              {lastSyncedTimeStamp && (
                <span className="text-xs text-[#A6A6A6]">
                  {lastSyncedTimeStamp}
                </span>
              )}
            </div>
          )}
          {status === "COMPLETED" && (
            <CardFooter className="flex justify-between items-center p-0 ">
              <div className="text-sm text-gray-400"></div>

              {campaignEnded && (
                <div className="flex flex-col items-end">
                  <div className="flex space-x-2">
                    {[1, 2, 3, 4, 5].map((value) => (
                      <Star
                        key={value}
                        className={cn(
                          "h-4 w-4 md:h-6 md:w-6 cursor-pointer transition-all",
                          hoverRating >= value || rating >= value
                            ? "fill-yellow-400 text-yellow-400"
                            : "text-red-400"
                        )}
                        onClick={() => handleRatingClick(value)}
                        onMouseEnter={() => handleMouseEnter(value)}
                        onMouseLeave={handleMouseLeave}
                      />
                    ))}
                  </div>
                  <span className="text-[10px] md:text-xs text-gray-400 mt-1">
                    {ratingGiven?.status === 1 || isSubmitted
                      ? "Thank you for your feedback!"
                      : "How was your experience?"}
                  </span>
                </div>
              )}
            </CardFooter>
          )}
        </div>
        {bottomSectionDataArray.length > 0 && (
          <div
            className="w-full flex flex-col md:flex-row justify-between gap-4 items-center overflow-x-scroll"
            style={{ scrollbarWidth: "none" }}
          >
            {postTracking?.updatedAt && (
              <div className="w-full">
                <TopPostCard
                  name={authState?.loggedUser?.name}
                  tagline={authState?.loggedUser?.tagline}
                  postLink={"trackingLink"}
                  postDescription={postTracking?.postContent}
                  profile={authState?.loggedUser?.profile}
                  likes={postTracking?.likes}
                  comments={postTracking?.comments}
                  reposts={postTracking?.reposts}
                />
              </div>
            )}

            <div
              className={cn(
                "flex w-full flex-col justify-between",
                postTracking?.updatedAt ? "flex-col" : "md:flex-row "
              )}
            >
              <div
                className={cn(
                  "grid grid-cols-2  md:whitespace-nowrap",
                  postTracking?.updatedAt ? "grid grid-cols-2" : "md:flex gap-2"
                )}
              >
                {(bottomSectionDataArray || [])?.map((item, index) => {
                  if (!item?.value) return null;
                  return (
                    <MetricsCard
                      key={index}
                      icon={item?.icon}
                      title={item?.title}
                      value={item?.value}
                      tooltip={item?.tooltip}
                    />
                  );
                })}
              </div>
              {postTracking?.updatedAt && (
                <div className="flex-col items-center gap-1 flex w-full md:w-auto justify-center">
                  {actionButton}
                  {lastSyncedTimeStamp && (
                    <span className="text-xs text-[#A6A6A6]">
                      {lastSyncedTimeStamp}
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        {!postTracking?.updatedAt && (
          <div className="md:hidden flex-col items-center gap-1 flex w-full md:w-auto justify-center">
            {actionButton}
            {lastSyncedTimeStamp && (
              <span className="text-xs text-[#A6A6A6]">
                {lastSyncedTimeStamp}
              </span>
            )}
          </div>
        )}
      </div>

      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent className="bg-gray-900 text-gray-200 border-gray-800 max-w-md pt-6">
          <div className="space-y-4 py-2 text-sm">
            <div className="space-y-2">
              <Label className="text-sm">
                1. How would you rate your overall experience working with this
                brand?
                <span className="block text-xs text-gray-400 mt-1">
                  (Consider factors like clear guidelines, smooth workflow, and
                  overall collaboration process)
                </span>
              </Label>
              <div className="flex justify-center py-1 space-x-2">
                {[1, 2, 3, 4, 5].map((value) => (
                  <Star
                    key={value}
                    className={cn(
                      "h-6 w-6 cursor-pointer transition-all",
                      experienceRating >= value
                        ? "fill-yellow-400 text-yellow-400"
                        : "text-red-400"
                    )}
                    onClick={() => setExperienceRating(value)}
                  />
                ))}
              </div>
            </div>

            <div className="space-y-2">
              <Label className="text-sm">
                2. How do you feel about the earnings from this campaign?
              </Label>
              <RadioGroup
                value={earningsRating}
                onValueChange={setEarningsRating}
                className="flex justify-center space-x-6 py-1"
              >
                <div className="flex flex-col items-center">
                  <Label
                    htmlFor="disappointed"
                    className={cn(
                      "text-2xl cursor-pointer",
                      earningsRating === "disappointed"
                        ? "opacity-100"
                        : "opacity-50"
                    )}
                  >
                    😞
                  </Label>
                  <RadioGroupItem
                    value="disappointed"
                    id="disappointed"
                    className="sr-only"
                  />
                  <span className="text-xs mt-1">Disappointed</span>
                </div>

                <div className="flex flex-col items-center">
                  <Label
                    htmlFor="neutral"
                    className={cn(
                      "text-2xl cursor-pointer",
                      earningsRating === "neutral"
                        ? "opacity-100"
                        : "opacity-50"
                    )}
                  >
                    😐
                  </Label>
                  <RadioGroupItem
                    value="neutral"
                    id="neutral"
                    className="sr-only"
                  />
                  <span className="text-xs mt-1">Neutral</span>
                </div>

                <div className="flex flex-col items-center">
                  <Label
                    htmlFor="satisfied"
                    className={cn(
                      "text-2xl cursor-pointer",
                      earningsRating === "satisfied"
                        ? "opacity-100"
                        : "opacity-50"
                    )}
                  >
                    😊
                  </Label>
                  <RadioGroupItem
                    value="satisfied"
                    id="satisfied"
                    className="sr-only"
                  />
                  <span className="text-xs mt-1">Satisfied</span>
                </div>
              </RadioGroup>
            </div>

            <div className="space-y-2">
              <Label className="text-sm">
                3. Were you happy with the creative freedom you had?
              </Label>
              <div className="flex justify-center py-1">
                <div className="bg-gray-800 rounded-lg p-1 flex">
                  <button
                    className={cn(
                      "px-4 py-1.5 rounded-md text-sm font-medium transition-colors",
                      creatorFreedom === "yes"
                        ? "bg-red-500 text-white"
                        : "bg-transparent text-gray-400 hover:text-white"
                    )}
                    onClick={() => setCreatorFreedom("yes")}
                  >
                    Yes
                  </button>
                  <button
                    className={cn(
                      "px-4 py-1.5 rounded-md text-sm font-medium transition-colors",
                      creatorFreedom === "no"
                        ? "bg-red-500 text-white"
                        : "bg-transparent text-gray-400 hover:text-white"
                    )}
                    onClick={() => setCreatorFreedom("no")}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>

            <div className="space-y-2">
              <Label htmlFor="improvements" className="text-sm">
                4. Please share any thoughts on improvements for the future.
              </Label>
              <Textarea
                value={review}
                onChange={(e) => setReview(e.target.value)}
                id="improvements"
                placeholder="I feel you can consider..."
                className="bg-gray-800 border-gray-700 h-16"
              />
            </div>

            <Button
              disabled={isSubmitting}
              className="w-full bg-red-500 hover:bg-red-600 text-white"
              onClick={handleSubmitFeedback}
            >
              {isSubmitting ? "Submitting..." : "Submit Feedback"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {showSuccessCard && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/70">
          <div className="relative w-full max-w-sm bg-gray-900 border border-gray-800 rounded-xl p-4 text-center shadow-xl">
            <button
              className="absolute top-3 right-3 bg-gray-800 rounded-full p-1 hover:bg-gray-700 transition-colors"
              onClick={() => setShowSuccessCard(false)}
            >
              <X className="h-4 w-4 text-gray-400" />
            </button>

            {/* Animated hearts */}
            {hearts.map((heart, i) => (
              <div
                key={i}
                className="absolute text-red-500 animate-pulse"
                style={{
                  left: `${heart.x}%`,
                  top: `${heart.y}%`,
                  fontSize: `${heart.size}px`,
                  opacity: heart.opacity,
                }}
              >
                ❤️
              </div>
            ))}

            <div className="relative w-32 h-32 mx-auto mb-2 rounded-full flex items-center justify-center overflow-hidden bg-red-100">
              <div
                className={`transition-transform duration-300 ${
                  bounce ? "translate-y-1" : "-translate-y-1"
                }`}
              >
                <div className="relative w-28 h-28">
                  <img
                    src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/creatorRatingCharacter.png"
                    alt="Happy character"
                    width={112}
                    height={112}
                    className="object-contain"
                  />
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-red-400 mb-1">Awesome!</h2>
            <p className="text-sm text-gray-300 mb-3">
              Thank you for sharing this feedback and helping us to build a
              better product for you.
            </p>

            <Button
              className="w-full bg-red-500 hover:bg-red-600 text-white font-medium"
              onClick={() => setShowSuccessCard(false)}
            >
              DONE
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export const PromotionalPostCheckForm = ({
  questions,
  handleSubmitAnswer,
}: PromotionalPostCheckFormProps) => {
  const [questionsData, setQuestionsData] = useState(questions);
  const [isOpenAlert, setIsOpenAlert] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);

  useEffect(() => {
    const updatedQuestions = questions.map((question) => ({
      ...question,
      selectionType: question.selectionType || "single",
    }));
    setQuestionsData(updatedQuestions);
  }, [questions]);

  const handleSelectOption = (optionKey, questionId) => {
    mixpanel.track("Selected Promotional Post Analysis Option", {
      question: questionsData.find((q) => q.id === questionId)?.title,
      option: optionKey,
    });

    const updatedQuestions = questionsData.map((question) => {
      if (question.id === questionId) {
        if (question.selectionType === "single") {
          return {
            ...question,
            selectedOptions: question.selectedOptions.includes(optionKey)
              ? []
              : [optionKey],
          };
        } else if (question.selectionType === "multiple") {
          return {
            ...question,
            selectedOptions: question.selectedOptions.includes(optionKey)
              ? question.selectedOptions.filter((key) => key !== optionKey)
              : [...question.selectedOptions, optionKey],
          };
        }
      }
      return question;
    });

    // If the first question is selected with 'no', reset all selectedOptions for other questions
    if (questionId === questionsData[0].id && optionKey === "no") {
      const resetQuestions = updatedQuestions.map((question, index) => {
        if (index !== 0) {
          return {
            ...question,
            selectedOptions: [],
          };
        }
        return question;
      });
      setQuestionsData(resetQuestions);
      setIsOpenAlert(true);
    } else {
      setQuestionsData(updatedQuestions);
    }

    //If the third question is selected with barter or free, filter out the fourth question
    if (questionId === questionsData[2].id) {
      if (optionKey === "barter" || optionKey === "free") {
        updatedQuestions[3].hide = true;
        updatedQuestions[3].selectedOptions = [];
        setQuestionsData(updatedQuestions);
      } else {
        updatedQuestions[3].hide = false;
        setQuestionsData(updatedQuestions);
      }
    }
  };

  const handleInputChange = (value, questionId) => {
    const updatedQuestions = questionsData.map((question) => {
      if (question.id === questionId) {
        return {
          ...question,
          selectedOptions: [value],
        };
      } else {
        return question;
      }
    });
    setQuestionsData(updatedQuestions);
  };

  const handleCancelSubmit = () => {
    setQuestionsData(questions);
    setIsOpenAlert(false);
  };

  const handleFormSubmit = async () => {
    setLoadingSave(true);
    const answers = questionsData.map((question) => {
      const selectedOptions = question?.selectedOptions.map((selectedKey) => {
        const option = question?.options.find((opt) => opt.key === selectedKey);
        return { key: selectedKey, value: option?.value };
      });
      return {
        questionId: question?.id,
        selectedOptions: selectedOptions,
      };
    });
    await handleSubmitAnswer({ answers: answers });
    setTimeout(() => {
      setLoadingSave(false);
    }, 1000);
  };

  useEffect(() => {
    if (!loadingSave) {
      setIsOpenAlert(false);
    }
  }, [loadingSave]);

  return (
    <>
      {isOpenAlert && (
        <AlertDialog open={isOpenAlert} onOpenChange={setIsOpenAlert}>
          <AlertDialogContent className="text-white border-none  shadow-[0px_10px_20px_0px_rgba(0,0,0,0.10)] rounded-lg bg-[#1B1F23] max-w-xl">
            <AlertDialogHeader>
              <AlertDialogTitle className="text-[#FFF] font-[Inter] text-base not-italic leading-[24px]">
                Are you sure?
              </AlertDialogTitle>
              <AlertDialogDescription className="text-[#A3A3A3] font-[Inter] text-sm not-italic font-normal leading-[20px]">
                Marking it as 'not a collab', will mean that it won't be shown
                to brands as a past collaboration on your profile
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel
                className="bg-transparent"
                onClick={handleCancelSubmit}
                disabled={loadingSave}
              >
                Cancel
              </AlertDialogCancel>
              <Button
                variant="destructive"
                onClick={handleFormSubmit}
                disabled={loadingSave}
              >
                {loadingSave && (
                  <Sparkles size={16} className="mr-2 animate-pulse" />
                )}
                Yes, I'm sure
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      )}

      <div>
        {questionsData
          ?.filter((item) => !item?.hide)
          ?.map((question, index) => {
            if (
              index !== 0 &&
              (!questionsData
                .slice(0, index)
                ?.filter((item) => !item?.hide)
                .every((q) => q?.selectedOptions?.length > 0) ||
                questionsData[0].selectedOptions?.includes("no"))
            ) {
              return null;
            }
            return (
              <div key={index}>
                <div className="text-[#A6A6A6] font-[Inter] text-xs not-italic font-semibold leading-[normal] flex gap-1 items-center">
                  {question?.title}
                  {question?.tooltip && (
                    <InfoToolTip
                      text={<p className="text-xs">{question?.tooltip}</p>}
                    />
                  )}
                </div>
                <div
                  className="flex gap-4 py-3 overflow-x-auto"
                  style={{ scrollbarWidth: "none" }}
                >
                  {question?.options?.map((option, index) => {
                    const isSelected = question?.selectedOptions?.includes(
                      option?.key
                    );
                    return (
                      <Button
                        key={index}
                        className={cn(
                          "bg-transparent flex gap-2 items-center py-1 px-4 text-sm border-[#A6A6A6] text-[#A6A6A6]",
                          isSelected
                            ? "bg-[#A6A6A6] text-black"
                            : option?.isSuggested
                            ? "border-[#DC2627] text-[#DC2627] hover:border-[#A6A6A6]"
                            : ""
                        )}
                        variant="outline"
                        size="sm"
                        onClick={() =>
                          handleSelectOption(option?.key, question?.id)
                        }
                      >
                        {isSelected && <CircleCheck size={16} />}
                        {option?.value}
                      </Button>
                    );
                  })}
                  {/* if question is input  */}
                  {!question?.hide && question?.isInput && (
                    <Input
                      type="number"
                      placeholder="Enter your answer"
                      className="bg-transparent flex gap-2 items-center py-1 px-4 text-sm border-[#A6A6A6] text-[#A6A6A6]"
                      onChange={(e) =>
                        handleInputChange(e.target.value, question?.id)
                      }
                      value={
                        questionsData.find((q) => q.id === question?.id)
                          ?.selectedOptions[0]
                      }
                      disabled={loadingSave}
                    />
                  )}
                </div>
              </div>
            );
          })}
        {questionsData
          ?.filter((item) => !item?.hide)
          ?.every((question) => question?.selectedOptions?.length > 0) && (
          <Button
            variant="destructive"
            size="sm"
            className="w-full mt-4"
            onClick={handleFormSubmit}
            disabled={loadingSave}
          >
            {loadingSave && (
              <Sparkles size={16} className="mr-2 animate-pulse" />
            )}
            Submit
          </Button>
        )}
      </div>
    </>
  );
};

export const SocialFieldCard = ({ audience, link, platform, icon }) => {
  return (
    <div
      className={`flex justify-between z-99 items-center self-stretch px-2 py-[3px] rounded border border-solid  ${getPlatformColor(
        platform
      )} `}
    >
      <div className=" flex items-center justify-center gap-2 ">
        <img className="w-[18px] h-[18px] " src={icon} alt="" />
        <span className="text-white text-center text-xs not-italic font-normal leading-5">
          {audience}
        </span>
      </div>
      {link && (
        <div
          onClick={() => window.open(link, "_blank")}
          className="flex text-[#3771C8] justify-center items-center gap-1 px-2 py-1.5 cursor-pointer"
        >
          <span className=" text-xs not-italic font-medium leading-[normal] cursoor-pointer">
            Open URL
          </span>
          <IoMdOpen size={14} />
        </div>
      )}
    </div>
  );
};
export const PlatformInfoCard = ({
  platformName,
  platformLink,
  redirectTo,
  goals,
  audience,
  icon,
  collabId = "",
  link = "",
  status = 0,
}) => {
  const navigate = useNavigate();

  const [openGetVerifyInfo, setOpenGetVerifyInfo] = useState(false);
  const [data, setData] = useState({
    link: link,
  });

  useEffect(() => {
    const fetchVerifyLink = async () => {
      try {
        const { data: resData } = await axios.get(
          `${
            import.meta.env.VITE_BACKEND_SERVER_URL
          }/influencer/getCollabVerifyLink/${collabId}`,
          {
            headers: {
              jwtToken: localStorage.getItem("jwtToken"),
            },
          }
        );

        if (resData?.success) {
          setData({
            ...data,
            link: resData?.link,
          });
        } else {
          toast.dark(resData?.error);
        }
      } catch (e) {
        console.error(e.message);
      }
    };

    if (openGetVerifyInfo === true) {
      fetchVerifyLink();
    }
  }, [openGetVerifyInfo]);

  return (
    <>
      {openGetVerifyInfo && (
        <PopupCard
          onClose={() => {
            mixpanel.track("Popup Closed");
            setOpenGetVerifyInfo(false);
          }}
        >
          <div className="size-full flex flex-col gap-4 items-center">
            <div className="w-full text-start space-y-2">
              <h1 className="text-[#FFF] font-[Inter] text-[16px] not-italic font-semibold leading-[18px]">
                Get Verified Your Collaboration
              </h1>
              <ul className="text-[#9093AA] font-[Inter] text-[12px] not-italic font-normal leading-[18px]">
                <li className="flex gap-1">
                  •<span>Get up to 300 chips on every verified collab</span>
                </li>
                <li className="flex gap-1">
                  •<span>Standout from other creators</span>
                </li>
                <li className="flex gap-1">
                  •<span>Get a verified badge on collab in public profile</span>
                </li>
              </ul>
            </div>
            <div className="w-full text-start space-y-2">
              <h1 className="text-[#FFF] font-[Inter] text-[16px] not-italic font-semibold leading-[18px]">
                How it works:
              </h1>
              <ul className="text-[#9093AA] font-[Inter] text-[12px] not-italic font-normal leading-[18px] text-pretty">
                <li className="flex gap-1">
                  •<span>Copy unique link & Copy icon</span>
                </li>
                <li className="flex gap-1">
                  •
                  <span>
                    Ask your company's collab manager to rate/review your collab
                  </span>
                </li>
                <li className="flex gap-1">
                  •
                  <span>
                    Once the manager filled out your reviews, you will get the
                    verified badge in the collab
                  </span>
                </li>
                <li className="flex gap-1">
                  •
                  <span>
                    Readymade email / DM template to share with the manager
                  </span>
                </li>
              </ul>
            </div>
            <div className="flex h-[40px] px-[16px] py-[8px] justify-between items-center gap-[10px] self-stretch rounded-[6px] bg-[#292929]">
              <div className="flex px-[8px] py-[6px] justify-start items-center gap-[15px] overflow-hidden">
                <VscGlobe size={18} color="#757575" className="shrink-0" />
                <span className="text-[#A3A3A3] text-[12px] font-normal leading-[20px] text-ellipsis whitespace-nowrap">
                  {data?.link
                    ? `${window.location.host}/brand/verify/${data?.link}`
                    : "Generting Link..."}
                </span>
              </div>
              <Button
                variant="ghost"
                size="icon"
                className="hover:bg-[#232323] hover:rounded-full px-[8px] py-[6px]"
                onClick={() => {
                  mixpanel.track("Copied Collab Verify Link");
                  navigator.clipboard.writeText(
                    `${window.location.protocol}//${window.location.host}/brand/verify/${data?.link}`
                  );

                  toast.dark("Collab Verify Link Copied", {
                    position: "top-center",
                    autoClose: 1000,
                  });
                }}
                disabled={!data?.link}
              >
                <MdContentCopy size={18} color="#757575" />
              </Button>
            </div>
            <div className="w-full flex justify-center items-center">
              {/* <Button variant="link" className="text-[#DC2627] flex gap-2"
                onClick={() => {
                  mixpanel.track("Clicked Collab Verify Check Template Button");
                }}>
                Check Template
                <MdOpenInNew size={14} />
              </Button> */}
            </div>
          </div>
        </PopupCard>
      )}

      <div className="flex flex-col justify-center items-start gap-2 self-stretch p-3 rounded border border-neutral-800 border-solid">
        <div className="flex justify-between items-center self-stretch">
          <span className="text-white flex gap-2 items-center cursor-pointer text-sm not-italic font-semibold leading-[normal]">
            <div className="flex gap-1 items-center justify-center ">
              {icon && (
                <img
                  className="w-[16px] h-[16px] rounded-full "
                  src={icon}
                  alt=""
                />
              )}
              {platformName}
            </div>

            {platformLink && (
              <LinkIcon
                onClick={() => {
                  mixpanel.track("Collab Profile - Company Link - Opened");
                  if (!/^https?:\/\//i.test(platformLink)) {
                    const Link = "https://" + platformLink;
                    return window.open(Link, "_blank");
                  }
                  window.open(platformLink, "_blank");
                }}
                size={14}
                color="#EF812D"
              />
            )}
          </span>

          {/* Get Verified Button */}
          {collabId && (
            <>
              <Button
                variant="link"
                size="sm"
                className="text-[#EF812D] text-xs"
                onClick={() => {
                  mixpanel.track("Clicked Collab Get Verify Info Button");
                  setOpenGetVerifyInfo(true);
                }}
                disabled={status === 1}
              >
                {status === 1 ? "Verified" : "Get Verified"}
              </Button>
              <Edit2Icon
                className="cursor-pointer"
                onClick={() => {
                  mixpanel.track("Collab Profile - Edit - Clicked");
                  navigate(redirectTo);
                }}
                size={14}
                color="#E2E8F0"
              />
            </>
          )}

          {audience && (
            <Edit2Icon
              className="cursor-pointer"
              onClick={() => navigate(redirectTo)}
              size={14}
              color="#E2E8F0"
            />
          )}
        </div>
        {audience && (
          <div className="flex  items-start gap-[8px] ">
            <User2Icon size={14} color="#3771C8" />
            <span className="text-neutral-400 text-xs not-italic font-semibold leading-[normal]">
              {audience}
            </span>
          </div>
        )}
        {goals && (
          <div className="flex items-start gap-2 flex-wrap">
            {goals?.map((item, index) => (
              <ChipsCard key={`platform_goals_${index}`} value={item} />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export const InfluencerWhatsappGroupCard = ({
  isProfileActive,
}: {
  isProfileActive: boolean;
}) => {
  return (
    <>
      <div className="flex flex-col items-start gap-2.5 flex-[1_0_0] self-stretch p-5 bg-[linear-gradient(0deg,rgba(32,176,56,0.12)_0%,rgba(96,214,106,0.12)_100%)] rounded-[10px] font-inter ">
        <div className="flex flex-col gap-1">
          <div
            className={`flex justify-center items-center gap-1 rounded border ${
              isProfileActive
                ? "bg-[rgba(38,220,44,0.16)] border-[rgba(124,196,30,0.16)]"
                : " bg-[rgba(255,0,0,0.16)] border-[rgba(255,0,0,0.16)] "
            }  px-2 py-[2px] border-solid `}
          >
            <span className="text-[color:var(--Shade-White,#FFF)] text-center text-[10px] not-italic font-normal leading-[normal]">
              {isProfileActive ? " YOU ARE ELIGIBLE" : " YOU ARE NOT ELIGIBLE "}
            </span>
            <span>{isProfileActive ? "😃" : "🙁"}</span>
          </div>
          {!isProfileActive && (
            <span className="text-[#AFB1B2] text-[10px] not-italic font-normal leading-[normal]">
              Tip: Activate your profile to be eligible
            </span>
          )}
        </div>

        <div className="flex items-center justify-center gap-2.5">
          <span>
            <BsWhatsapp color="green" size={20} />
          </span>
          <span className="text-[color:var(--Shade-White,#FFF)] text-center text-sm md:text-base not-italic font-bold leading-5">
            Exclusive WhatsApp Group
          </span>
        </div>
        <span className="text-[#ADADAD] text-[11px] md:text-xs not-italic font-normal leading-5">
          Here you can talk to your fellow creators about anything, ask for help
          offer tips & tricks, alert them of bad practices & so on. Important
          alerts are shared here as well.
        </span>
        <Button
          onClick={() => {
            if (isProfileActive) {
              OpenInNewWindow({ link: "https://go.anchors.in/anchors_WA" });
            } else {
              return;
            }
          }}
          disabled={!isProfileActive}
          className="text-[#121212] w-full md:w-auto py-1  text-sm not-italic font-semibold leading-6"
          variant="outline"
        >
          Yes, I want to Join
        </Button>
      </div>
    </>
  );
};

const StrengthProgressBar = ({
  currentProfileStrength,
}: {
  currentProfileStrength: number;
}) => {
  const [animationPosition, setAnimationPosition] = useState(0);
  const strengthBars = [
    {
      gradient: "bg-[linear-gradient(90deg,#B546FF_0%,#1225FF_100%)]",
      level: 1,
    },
    { gradient: "bg-[linear-gradient(90deg,#1225FF_0%,#0CF_100%)]", level: 2 },
    { gradient: "bg-[linear-gradient(90deg,#0CF_0%,#27DB0B_100%)]", level: 3 },
    {
      gradient: "bg-[linear-gradient(90deg,#27DB0B_0%,#107300_100%)]",
      level: 4,
    },
  ];

  useEffect(() => {
    setTimeout(() => {
      setAnimationPosition(currentProfileStrength);
    }, 1000);
  }, [currentProfileStrength]);

  return (
    <div className="flex h-[19px] justify-center items-center self-stretch pt-[7px] pb-1.5 px-0 relative">
      <div className="flex gap-1 w-full">
        {strengthBars.map(({ gradient, level }) => (
          <div
            key={level}
            className={`h-1.5 relative flex-[1_0_0] ${gradient}`}
          ></div>
        ))}
      </div>
      {/* Animated Checkmark */}
      <div
        className="w-[19px] h-[19px] absolute top-[-1px] flex items-center justify-center bg-[linear-gradient(90deg,#B546FF_0%,#1225FF_100%)] rounded-full transition-all duration-1000"
        style={{
          left: `${animationPosition * 24}%`, // Calculate position dynamically
        }}
      >
        <div className="w-[16px] flex items-center justify-center h-[16px] bg-white rounded-full">
          <Check color="#B546FF" size={14} />
        </div>
      </div>
    </div>
  );
};

export const InfluencerProfileStrength = ({
  currentProfileStrength,
}: {
  currentProfileStrength: number;
}) => {
  const [fade, setFade] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setFade(true);
    }, 1000);
  }, []);
  return (
    <>
      <div className="flex flex-col items-start gap-5 flex-[1_0_0] bg-[rgba(89,155,255,0.20)] p-5 rounded-[10px] font-inter">
        <div className="flex flex-col items-start gap-1.5 self-stretch">
          <div className="flex items-center gap-2.5 ">
            <span>
              <IoPersonOutline color="#9DB0FF" />
            </span>
            <span className=" text-[color:var(--Shade-White,#FFF)] text-center text-sm md:text-base not-italic font-bold leading-5">
              Your Profile Strength
            </span>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Info className="cursor-pointer" color="#9DB0FF" size={17} />
                </TooltipTrigger>
                <TooltipContent className="max-w-sm text-left">
                  {
                    "To keep your profile strong, sync regularly, add past collabs and monetization info. More details = better visibility."
                  }
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
          <span className="text-[#ADADAD] text-[11px] md:text-xs not-italic font-normal leading-5">
            The stronger your profile, the higher the chances of a brand
            choosing you for a collaboration
          </span>
        </div>
        <div className="flex flex-col items-start gap-1.5 self-stretch">
          <div className="flex gap-1 items-center ">
            <span className="text-[color:var(--Shade-White,#FFF)] text-center text-sm not-italic font-normal leading-5">
              Profile Strength:
            </span>
            <button
              className={cn(
                `text-[color:var(--Shade-White,#FFF)] text-center text-[10px] not-italic font-normal leading-[normal] flex justify-center items-center gap-1 bg-[#DC2627] px-2 py-1 rounded-sm transition-opacity duration-1000  `,
                profileStrengthBackground?.[currentProfileStrength],
                fade ? "opacity-100 " : "opacity-0 "
              )}
            >
              {profileStrengthText?.[currentProfileStrength]}
            </button>
          </div>
          <StrengthProgressBar
            currentProfileStrength={currentProfileStrength}
          />
        </div>
      </div>
    </>
  );
};

export const NoCollabErrorMessage = ({ className }: { className?: string }) => {
  const navigate = useNavigate();
  return (
    <div
      className={cn(
        "w-full flex h-full items-center justify-center ",
        className
      )}
    >
      <div className="flex w-96 flex-col items-center gap-5">
        <div className="w-10 h-10 overflow-hidden ">
          <img
            className="w-full h-full"
            src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/image+54.png"
            alt=""
          />
        </div>
        <div className="flex flex-col items-center gap-1.5 self-stretch">
          <span className="text-[rgba(255,255,255,0.80)] text-center text-sm not-italic font-bold leading-5">
            No collabs yet :(
          </span>
          <span className="text-[#ADADAD] text-center text-xs not-italic font-normal leading-5">
            In the meantime, explore past brand collaborations by your fellow
            creators in the Collab Feed for inspiration and ideas.
          </span>
        </div>
        <span
          onClick={() => navigate("/influencer/feed")}
          className="flex justify-center items-center gap-2.5 px-4 py-0 text-[#DC2627] text-sm not-italic font-bold leading-6 cursor-pointer "
        >
          Go to feed <ArrowRight size={14} />{" "}
        </span>
      </div>
    </div>
  );
};
